//* Ajaxify.js.liquid *//

/* ================ SLATE ================ */ 
window.theme = window.theme || {};
var _0x4931=["\x64\x61\x74\x61\x2D\x73\x66\x6C\x63","\x67\x65\x74\x41\x74\x74\x72\x69\x62\x75\x74\x65","\x73\x66\x6C\x63","\x67\x65\x74\x45\x6C\x65\x6D\x65\x6E\x74\x42\x79\x49\x64","\x6C\x65\x6E\x67\x74\x68","\x73\x66\x63","\x74\x68\x65\x6D\x65","\x62\x6F\x64\x79","\x71\x75\x65\x72\x79\x53\x65\x6C\x65\x63\x74\x6F\x72","\x64\x69\x76","\x63\x72\x65\x61\x74\x65\x45\x6C\x65\x6D\x65\x6E\x74","\x62\x75\x74\x74\x6F\x6E","\x68\x32","\x70","\x73\x66\x2D\x74\x72","\x61\x64\x64","\x63\x6C\x61\x73\x73\x4C\x69\x73\x74","\x73\x66\x2D\x74\x68\x2D\x76","\x73\x66\x2D\x74\x68\x2D\x76\x2D\x2D\x63\x6C\x6F\x73\x65","\x62\x61\x63\x6B\x67\x72\x6F\x75\x6E\x64\x43\x6F\x6C\x6F\x72","\x73\x74\x79\x6C\x65","\x23\x46\x46\x46\x46\x46\x46","\x62\x6F\x78\x53\x68\x61\x64\x6F\x77","\x30\x20\x30\x20\x35\x30\x70\x78\x20\x23\x36\x36\x36","\x70\x6F\x73\x69\x74\x69\x6F\x6E","\x66\x69\x78\x65\x64","\x74\x6F\x70","\x33\x30\x25","\x6C\x65\x66\x74","\x33\x35\x25","\x77\x69\x64\x74\x68","\x70\x61\x64\x64\x69\x6E\x67","\x32\x35\x70\x78","\x74\x65\x78\x74\x41\x6C\x69\x67\x6E","\x63\x65\x6E\x74\x65\x72","\x61\x62\x73\x6F\x6C\x75\x74\x65","\x32\x25","\x72\x69\x67\x68\x74","\x61\x63\x74\x69\x76\x65","\x63\x75\x72\x72\x65\x6E\x63\x79","\x45\x55\x52","\x74\x65\x78\x74\x43\x6F\x6E\x74\x65\x6E\x74","\x54\x47\x6C\x6A\x5A\x57\x35\x6A\x5A\x53\x42\x75\x62\x32\x34\x67\x59\x57\x4E\x30\x61\x58\x62\x70\x5A\x51\x3D\x3D","\x56\x6D\x56\x31\x61\x57\x78\x73\x5A\x58\x6F\x67\x63\x6D\x56\x75\x63\x32\x56\x70\x5A\x32\x35\x6C\x63\x69\x42\x32\x62\x33\x52\x79\x5A\x53\x42\x75\x64\x57\x33\x70\x63\x6D\x38\x67\x5A\x47\x55\x67\x62\x47\x6C\x6A\x5A\x57\x35\x6A\x5A\x53\x42\x6B\x59\x57\x35\x7A\x49\x47\x77\x6E\x59\x58\x42\x77\x62\x47\x6C\x6A\x59\x58\x52\x70\x62\x32\x34\x67\x55\x33\x42\x6C\x5A\x57\x51\x67\x52\x57\x4E\x76\x62\x53\x42\x68\x5A\x6D\x6C\x75\x49\x47\x52\x6C\x49\x47\x54\x70\x59\x6D\x78\x76\x63\x58\x56\x6C\x63\x69\x42\x32\x62\x33\x52\x79\x5A\x53\x42\x30\x61\x4F\x68\x74\x5A\x53\x34\x67\x56\x6D\x39\x31\x63\x79\x44\x71\x64\x47\x56\x7A\x49\x47\x56\x75\x49\x48\x5A\x6C\x63\x6E\x4E\x70\x62\x32\x34\x67\x5A\x43\x64\x6C\x63\x33\x4E\x68\x61\x53\x41\x2F\x49\x46\x5A\x76\x64\x48\x4A\x6C\x49\x47\x35\x31\x62\x65\x6C\x79\x62\x79\x42\x6B\x5A\x53\x42\x73\x61\x57\x4E\x6C\x62\x6D\x4E\x6C\x49\x48\x5A\x76\x64\x58\x4D\x67\x63\x32\x56\x79\x59\x53\x42\x6C\x62\x6E\x5A\x76\x65\x65\x6B\x67\x34\x43\x42\x73\x59\x53\x42\x6D\x61\x57\x34\x67\x5A\x47\x55\x67\x59\x32\x56\x30\x64\x47\x55\x67\x63\x4F\x6C\x79\x61\x57\x39\x6B\x5A\x53\x34\x3D","\x54\x2F\x6B\x67\x64\x48\x4A\x76\x64\x58\x5A\x6C\x63\x69\x42\x74\x59\x53\x42\x73\x61\x57\x4E\x6C\x62\x6D\x4E\x6C","\x51\x32\x39\x74\x62\x57\x56\x75\x64\x43\x42\x68\x59\x33\x52\x70\x64\x6D\x56\x79\x49\x47\x31\x68\x49\x47\x78\x70\x59\x32\x56\x75\x59\x32\x55\x3D","\x52\x57\x34\x67\x63\x32\x46\x32\x62\x32\x6C\x79\x49\x48\x42\x73\x64\x58\x4D\x67\x63\x33\x56\x79\x49\x47\x78\x6C\x49\x48\x4E\x35\x63\x33\x54\x6F\x62\x57\x55\x67\x5A\x47\x55\x67\x62\x47\x6C\x6A\x5A\x57\x35\x6A\x5A\x51\x3D\x3D","\x69\x6E\x6E\x65\x72\x48\x54\x4D\x4C","\x3C\x61\x20\x68\x72\x65\x66\x3D\x22\x68\x74\x74\x70\x73\x3A\x2F\x2F\x73\x70\x65\x65\x64\x2D\x65\x63\x6F\x6D\x2E\x65\x75\x2F\x6D\x6F\x6E\x2D\x63\x6F\x6D\x70\x74\x65\x2F\x64\x6F\x77\x6E\x6C\x6F\x61\x64\x73\x2F\x22\x20\x74\x61\x72\x67\x65\x74\x3D\x22\x5F\x62\x6C\x61\x6E\x6B\x22\x3E","\x3C\x2F\x61\x3E\x20\x2D\x20\x3C\x61\x20\x68\x72\x65\x66\x3D\x22\x68\x74\x74\x70\x73\x3A\x2F\x2F\x79\x6F\x75\x74\x75\x2E\x62\x65\x2F\x56\x33\x39\x6A\x67\x6F\x41\x6A\x44\x37\x49\x3F\x74\x3D\x32\x30\x31\x22\x20\x74\x61\x72\x67\x65\x74\x3D\x22\x5F\x62\x6C\x61\x6E\x6B\x22\x3E","\x3C\x2F\x61\x3E\x20\x2D\x20\x3C\x61\x20\x68\x72\x65\x66\x3D\x22\x68\x74\x74\x70\x73\x3A\x2F\x2F\x73\x70\x65\x65\x64\x2D\x65\x63\x6F\x6D\x2E\x65\x75\x2F\x73\x70\x65\x65\x64\x66\x6C\x79\x2D\x6C\x69\x63\x65\x6E\x63\x65\x22\x20\x74\x61\x72\x67\x65\x74\x3D\x22\x5F\x62\x6C\x61\x6E\x6B\x22\x3E","\x3C\x2F\x61\x3E","\x54\x47\x6C\x6A\x5A\x57\x35\x7A\x5A\x53\x42\x75\x62\x33\x51\x67\x59\x57\x4E\x30\x61\x58\x5A\x68\x64\x47\x56\x6B","\x55\x47\x78\x6C\x59\x58\x4E\x6C\x49\x47\x56\x75\x64\x47\x56\x79\x49\x48\x6C\x76\x64\x58\x49\x67\x62\x47\x6C\x6A\x5A\x57\x35\x7A\x5A\x53\x42\x75\x64\x57\x31\x69\x5A\x58\x49\x67\x61\x57\x34\x67\x64\x47\x68\x6C\x49\x46\x4E\x77\x5A\x57\x56\x6B\x49\x45\x56\x6A\x62\x32\x30\x67\x59\x58\x42\x77\x62\x47\x6C\x6A\x59\x58\x52\x70\x62\x32\x34\x67\x64\x47\x38\x67\x64\x57\x35\x73\x62\x32\x4E\x72\x49\x48\x6C\x76\x64\x58\x49\x67\x64\x47\x68\x6C\x62\x57\x55\x75\x49\x46\x52\x6F\x61\x58\x4D\x67\x61\x58\x4D\x67\x64\x47\x68\x6C\x49\x48\x52\x79\x61\x57\x46\x73\x49\x48\x5A\x6C\x63\x6E\x4E\x70\x62\x32\x34\x67\x50\x79\x42\x5A\x62\x33\x56\x79\x49\x47\x78\x70\x59\x32\x56\x75\x59\x32\x55\x67\x62\x6E\x56\x74\x59\x6D\x56\x79\x49\x48\x64\x70\x62\x47\x77\x67\x59\x6D\x55\x67\x63\x32\x56\x75\x64\x43\x42\x30\x62\x79\x42\x35\x62\x33\x55\x67\x59\x58\x51\x67\x64\x47\x68\x6C\x49\x47\x56\x75\x5A\x43\x42\x76\x5A\x69\x42\x30\x61\x47\x55\x67\x64\x48\x4A\x70\x59\x57\x77\x75","\x3C\x2F\x61\x3E\x20\x2D\x20\x3C\x61\x20\x68\x72\x65\x66\x3D\x22\x23\x22\x20\x74\x61\x72\x67\x65\x74\x3D\x22\x5F\x62\x6C\x61\x6E\x6B\x22\x3E","\x78","\x61\x70\x70\x65\x6E\x64","\x61\x70\x70\x65\x6E\x64\x43\x68\x69\x6C\x64","\x64\x69\x73\x70\x6C\x61\x79","\x6E\x6F\x6E\x65","\x69\x6D\x70\x6F\x72\x74\x61\x6E\x74","\x73\x65\x74\x50\x72\x6F\x70\x65\x72\x74\x79","\x2E\x73\x66\x2D\x74\x68\x2D\x76","\x62\x6C\x6F\x63\x6B","\x63\x6C\x69\x63\x6B","\x61\x64\x64\x45\x76\x65\x6E\x74\x4C\x69\x73\x74\x65\x6E\x65\x72","\x2E\x73\x66\x2D\x74\x68\x2D\x76\x2D\x2D\x63\x6C\x6F\x73\x65"];const sflc=document[_0x4931[3]](_0x4931[2])[_0x4931[1]](_0x4931[0]);if(sflc[_0x4931[4]]!= 40&& Shopify[_0x4931[6]][_0x4931[5]]!= 40){const sfBody=document[_0x4931[8]](_0x4931[7]);const sfDiv=document[_0x4931[10]](_0x4931[9]);const sfBtn=document[_0x4931[10]](_0x4931[11]);const sfTitle=document[_0x4931[10]](_0x4931[12]);const sfText=document[_0x4931[10]](_0x4931[13]);sfBody[_0x4931[16]][_0x4931[15]](_0x4931[14]);sfDiv[_0x4931[16]][_0x4931[15]](_0x4931[17]);sfBtn[_0x4931[16]][_0x4931[15]](_0x4931[18]);sfDiv[_0x4931[20]][_0x4931[19]]= _0x4931[21];sfDiv[_0x4931[20]][_0x4931[22]]= _0x4931[23];sfDiv[_0x4931[20]][_0x4931[24]]= _0x4931[25];sfDiv[_0x4931[20]][_0x4931[26]]= _0x4931[27];sfDiv[_0x4931[20]][_0x4931[28]]= _0x4931[29];sfDiv[_0x4931[20]][_0x4931[30]]= _0x4931[27];sfDiv[_0x4931[20]][_0x4931[31]]= _0x4931[32];sfDiv[_0x4931[20]][_0x4931[33]]= _0x4931[34];sfBtn[_0x4931[20]][_0x4931[24]]= _0x4931[35];sfBtn[_0x4931[20]][_0x4931[26]]= _0x4931[36];sfBtn[_0x4931[20]][_0x4931[37]]= _0x4931[36];const sfLinks=document[_0x4931[10]](_0x4931[9]);if(Shopify[_0x4931[39]][_0x4931[38]]== _0x4931[40]){sfTitle[_0x4931[41]]= atob(`${_0x4931[42]}`);sfText[_0x4931[41]]= atob(`${_0x4931[43]}`);const sfLinksText1=atob(`${_0x4931[44]}`);const sfLinksText2=atob(`${_0x4931[45]}`);const sfLinksText3=atob(`${_0x4931[46]}`);sfLinks[_0x4931[47]]= `${_0x4931[48]}${sfLinksText1}${_0x4931[49]}${sfLinksText2}${_0x4931[50]}${sfLinksText3}${_0x4931[51]}`}else {sfTitle[_0x4931[41]]= atob(`${_0x4931[52]}`);sfText[_0x4931[41]]= atob(`${_0x4931[53]}`);const sfLinksText1=atob(`${_0x4931[44]}`);const sfLinksText2=atob(`${_0x4931[45]}`);const sfLinksText3=atob(`${_0x4931[46]}`);sfLinks[_0x4931[47]]= `${_0x4931[48]}${sfLinksText1}${_0x4931[54]}${sfLinksText2}${_0x4931[50]}${sfLinksText3}${_0x4931[51]}`};sfBtn[_0x4931[41]]= _0x4931[55];sfBody[_0x4931[56]](sfDiv);sfDiv[_0x4931[56]](sfTitle);sfDiv[_0x4931[56]](sfText);sfDiv[_0x4931[56]](sfBtn);sfDiv[_0x4931[57]](sfLinks);document[_0x4931[8]](_0x4931[62])[_0x4931[20]][_0x4931[61]](_0x4931[58],_0x4931[59],_0x4931[60]);const sfLcVShow=()=>{return document[_0x4931[8]](_0x4931[62])[_0x4931[20]][_0x4931[61]](_0x4931[58],_0x4931[63],_0x4931[60])};const sfLcVHide=()=>{document[_0x4931[8]](_0x4931[66])[_0x4931[65]](_0x4931[64],()=>{document[_0x4931[8]](_0x4931[62])[_0x4931[20]][_0x4931[61]](_0x4931[58],_0x4931[59],_0x4931[60])})};setTimeout(function(){sfLcVShow();sfLcVHide()},15000)}
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});
var _0xe0e4=["\x44\x4F\x4D\x43\x6F\x6E\x74\x65\x6E\x74\x4C\x6F\x61\x64\x65\x64","\x73\x66\x63","\x74\x68\x65\x6D\x65","\x6C\x65\x6E\x67\x74\x68","\x63\x6F\x6E\x66\x69\x72\x6D","\x68\x72\x65\x66","\x6C\x6F\x63\x61\x74\x69\x6F\x6E","\x68\x74\x74\x70\x73\x3A\x2F\x2F\x73\x70\x65\x65\x64\x2D\x65\x63\x6F\x6D\x2E\x65\x75\x2F\x73\x70\x65\x65\x64\x66\x6C\x79\x2D\x6C\x69\x63\x65\x6E\x63\x65","\x2E\x67\x6F\x2D\x70\x61\x79","\x71\x75\x65\x72\x79\x53\x65\x6C\x65\x63\x74\x6F\x72\x41\x6C\x6C","\x63\x6C\x69\x63\x6B","\x70\x72\x65\x76\x65\x6E\x74\x44\x65\x66\x61\x75\x6C\x74","\x61\x63\x74\x69\x76\x65","\x63\x75\x72\x72\x65\x6E\x63\x79","\x45\x55\x52","\x54\x43\x64\x68\x59\x32\x50\x6F\x63\x79\x42\x68\x64\x53\x42\x6A\x61\x47\x56\x6A\x61\x32\x39\x31\x64\x43\x42\x6C\x63\x33\x51\x67\x5A\x4F\x6C\x7A\x59\x57\x4E\x30\x61\x58\x62\x70\x4C\x69\x42\x57\x5A\x58\x56\x70\x62\x47\x78\x6C\x65\x69\x42\x68\x59\x33\x52\x70\x64\x6D\x56\x79\x49\x48\x5A\x76\x64\x48\x4A\x6C\x49\x47\x78\x70\x59\x32\x56\x75\x59\x32\x55\x67\x63\x47\x39\x31\x63\x69\x42\x73\x5A\x53\x42\x6B\x36\x57\x4A\x73\x62\x33\x46\x31\x5A\x58\x49\x75","\x52\x57\x34\x67\x63\x32\x46\x32\x62\x32\x6C\x79\x49\x48\x42\x73\x64\x58\x4D\x67\x63\x33\x56\x79\x49\x47\x78\x6C\x49\x48\x4E\x35\x63\x33\x54\x6F\x62\x57\x55\x67\x5A\x47\x55\x67\x62\x47\x6C\x6A\x5A\x57\x35\x6A\x5A\x53\x41","\x51\x57\x4E\x6A\x5A\x58\x4E\x7A\x49\x48\x52\x76\x49\x48\x52\x6F\x5A\x53\x42\x6A\x61\x47\x56\x6A\x61\x32\x39\x31\x64\x43\x42\x70\x63\x79\x42\x6B\x61\x58\x4E\x68\x59\x6D\x78\x6C\x5A\x43\x34\x67\x55\x47\x78\x6C\x59\x58\x4E\x6C\x49\x47\x46\x6A\x64\x47\x6C\x32\x59\x58\x52\x6C\x49\x48\x6C\x76\x64\x58\x49\x67\x62\x47\x6C\x6A\x5A\x57\x35\x7A\x5A\x53\x42\x30\x62\x79\x42\x31\x62\x6D\x78\x76\x59\x32\x73\x67\x61\x58\x51\x75","\x54\x47\x56\x68\x63\x6D\x34\x67\x62\x57\x39\x79\x5A\x53\x42\x68\x59\x6D\x39\x31\x64\x43\x42\x30\x61\x47\x55\x67\x62\x47\x6C\x6A\x5A\x57\x35\x7A\x61\x57\x35\x6E\x49\x48\x4E\x35\x63\x33\x52\x6C\x62\x53\x41\x2F","\x61\x64\x64\x45\x76\x65\x6E\x74\x4C\x69\x73\x74\x65\x6E\x65\x72","\x66\x6F\x72\x45\x61\x63\x68"];window[_0xe0e4[19]](_0xe0e4[0],(_0xe2d5x1)=>{Shopify[_0xe0e4[2]][_0xe0e4[1]]= sflc;function _0xe2d5x2(){if(Shopify[_0xe0e4[2]][_0xe0e4[1]][_0xe0e4[3]]!= 40){function _0xe2d5x3(_0xe2d5x4,_0xe2d5x5){alert(_0xe2d5x4);if(window[_0xe0e4[4]](_0xe2d5x5)){return window[_0xe0e4[6]][_0xe0e4[5]]= _0xe0e4[7]}}const _0xe2d5x6=document[_0xe0e4[9]](_0xe0e4[8]);_0xe2d5x6[_0xe0e4[20]]((_0xe2d5x7)=>{_0xe2d5x7[_0xe0e4[19]](_0xe0e4[10],function(_0xe2d5x8){_0xe2d5x8[_0xe0e4[11]]();if(Shopify[_0xe0e4[13]][_0xe0e4[12]]== _0xe0e4[14]){let _0xe2d5x4=atob(`${_0xe0e4[15]}`);let _0xe2d5x5=atob(`${_0xe0e4[16]}`);_0xe2d5x3(_0xe2d5x4,_0xe2d5x5)}else {let _0xe2d5x4=atob(`${_0xe0e4[17]}`);let _0xe2d5x5=atob(`${_0xe0e4[18]}`);_0xe2d5x3(_0xe2d5x4,_0xe2d5x5)}})})}}_0xe2d5x2()})
/* ================ MODULES ================ */
/* eslint-disable no-new */
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),
    $breadcrumbs: $('.breadcrumb'),

    // Navigation
    $navigation: $('#accessibleNav'),
    $hasDropdownItem: $('.site-nav--has-dropdown'),
    $menuToggle: $('.menu-toggle'),

    // Product Page
    
    $productImageWrap: $('#productPhoto'),
    $productImage: $('#productPhotoImg'),
    $thumbImages: $('#productThumbs').find('a.product-photo-thumb'),
    $shareButtons: $('.social-sharing'),

    // Collection Pages
    $collectionFilters: $('#collectionFilters'),
    $advancedFilters: $('.advanced-filters'),
    $toggleFilterBtn: $('#toggleFilters'),

    // Cart Pages
    $emptyCart: $('#EmptyCart'),
    $ajaxCartContainer: $('#ajaxifyCart'),
    cartNoCookies: 'cart--no-cookies',

    // Equal height elements
    $featuredContainer: $('.featured-box').closest('.grid-uniform'),   
    $productGridImages: $('.product-grid-image')
    
    
  };
};

timber.cacheVariables = function () {
  timber.vars = {
    // Breakpoints (from timber.scss.liquid)
    bpLarge: 1024,

    // MediaQueries (from timber.scss.liquid)
    mediaQueryLarge     : 'screen and (min-width: 1024px)',
    isLargeBp : false,
    isTouch: timber.cache.$html.hasClass('supports-touch')
  }
};

timber.init = function () {
 // FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.cacheVariables();

  timber.cache.$html.removeClass('no-js').addClass('js');
  if ('ontouchstart' in window) {
    timber.cache.$html.removeClass('no-touch').addClass('touch');
  }

  timber.initCart();
  
  //timber.equalHeights();
  
  timber.responsiveVideos();
  timber.toggleFilters();


  
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav--dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter', function(evt) {
    var el = $(this);

    if (!el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($(this));
  });

  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('click', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus (el) {
    var $subMenu = el.next('ul'),
        hasSubMenu = $subMenu.hasClass('site-nav--dropdown') ? true : false,
        isSubItem = $('.site-nav--dropdown').has(el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if ( !isSubItem ) {
      removeFocus($topLevel);
      addFocus(el);
    } else {
      $newFocus = el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown (el) {
    el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown(el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.responsiveNav = function () {
  $(window).resize(function () {
    
      // Replace original nav items and remove more link
      timber.cache.$navigation.append($('#moreMenu--list').html());
      $('#moreMenu').remove();
      timber.alignMenu();
      timber.accessibleNav();
    
  });
  timber.alignMenu();
  timber.accessibleNav();
};

timber.alignMenu = function () {
  var $nav = timber.cache.$navigation,
      w = -5,
      i = 0;
  wrapperWidth = $nav.outerWidth() - 101,
    menuhtml = '';

  if ( window.innerWidth < timber.vars.bpLarge ) {
    return;
  }

  $.each($nav.children(), function () {
    var $el = $(this);

    // Ignore hidden customer links (for mobile)
    if (!$el.hasClass('large-hide')) {
      w += $el.outerWidth(true);
    }

    if (wrapperWidth == w) {
      menuhtml += $('<div>').append($el.clone()).html();
      $el.remove();

      // Ignore hidden customer links (for mobile)
      if (!$el.hasClass('large-hide')) {
        i++;
      }
    }
  });

  if (wrapperWidth == w) {
    $nav.append(
      '<li id="moreMenu" class="site-nav--has-dropdown">'
      + '<a href="#">' + theme.strings.navigation.more_link + '<span class="icon icon-arrow-down" aria-hidden="true"></span></a>'
      + '<ul id="moreMenu--list" class="site-nav--dropdown">' + menuhtml + '</ul></li>'
    );

    if (i <= 1) {
      // Bail, and replace original nav items
      timber.cache.$navigation.append($('#moreMenu--list').html());
      $('#moreMenu').remove();
    }
  }
};

timber.toggleMenu = function () {
  var $doc = $(document);
  var showDropdownClass = 'show-dropdown';
  var showNavClass = 'show-nav';

  timber.cache.$menuToggle.on('click', function() {
    timber.cache.$html.toggleClass(showNavClass);    
    // Close ajax cart if open (keep selectors live, modal is inserted with JS)
    if ( $('#ajaxifyModal').hasClass('is-visible') ) {
      $('#ajaxifyModal').removeClass('is-visible');
      timber.cache.$html.addClass(showNavClass);
    }
  });
  
  if (window.matchMedia("(max-width: 1023px)").matches) { 
  function dropDown(elem) {
    var acc = document.getElementsByClassName(elem);
    var i;   

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        
        if(elem == "level1-title" || elem == "level2-title") {
          var panelBefore = this.nextElementSibling;
          var panel = panelBefore.nextElementSibling;
          panelBefore.classList.toggle("active");
        }
        else {
          this.classList.toggle("active");
          var panel = this.nextElementSibling;  
        }    
        
        if (panel.style.display === "block") {
          panel.style.display = "none";       
        } else {
          panel.style.display = "block";
        }
      }, {passive: true});
    }
  }
  dropDown("level1-title");
  dropDown("level1");
  dropDown("level2-title");
  dropDown("level2");
  
  jQuery(document).on('shopify:section:load', function(){
    dropDown("level1-title");
    dropDown("level1");
    dropDown("level2-title");
    dropDown("level2");
  });
  } 
};

timber.initCart = function() {
  if (!timber.cookiesEnabled()) {
    timber.cache.$emptyCart.addClass(timber.cache.cartNoCookies);
    timber.cache.$ajaxCartContainer.addClass(timber.cache.cartNoCookies);
  }
};

timber.cookiesEnabled = function() {
  var cookieEnabled = navigator.cookieEnabled;
  if (!cookieEnabled){
    document.cookie = 'testcookie';
    cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
  }
  return cookieEnabled;
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive but not for video sections
    if(!$(this).parent('div.video-wrapper').length) {
      $(this).wrap('<div class="video-wrapper"></div>');
    };
  });

  $iframeReset.each(function () {
    
    this.src = this.src;
  });
};

timber.toggleFilters = function () {
  if ( timber.cache.$collectionFilters.length ) {
    timber.cache.$toggleFilterBtn.on('click', function() {
      timber.cache.$toggleFilterBtn.toggleClass('is-active');
      timber.cache.$collectionFilters.slideToggle(200);

      // Scroll to top of filters if user is down the page a bit
      if ( $(window).scrollTop() > timber.cache.$breadcrumbs.offset().top ) {
        $('html, body').animate({
          scrollTop: timber.cache.$breadcrumbs.offset().top
        });
      }
    });
  }
};

timber.sortFilters = function () {
  timber.cache.$advancedFilters.each(function () {
    var $el = $(this),
        $tags = $el.find('li'),
        aNumber = /\d+/,
        sorted = false;
    $tags.sort(function (a, b) {
      a = parseInt( aNumber.exec( $(a).text() ), 10 );
      b = parseInt( aNumber.exec( $(b).text() ), 10 );
      if ( isNaN(a)  || isNaN(b) ) {
        return;
      }
      else {
        sorted = true;
        return a - b;
      }
    });
    if (sorted) {
      $el.append($tags);
    }
  });
};

timber.formatMoney = function (val) {

       

  return val;
};

timber.formatSaleTag = function (val) {
  // If not using multiple currencies
  if (moneyFormat.indexOf('money') === -1) {
    // If we use amount
    if ( (moneyFormat.indexOf('{{amount}}') > -1) && (moneyFormat.indexOf('.') === -1) ) {
      // If there are no cents or money amount is more than 10, remove decimals
      if ( (val.indexOf('.00') > -1) || parseInt(val.replace(/[^0-9]/g, ''), 10) > 1000 ) {
        return val.split('.')[0];
      }
    }
    // If we use amount_with_comma_separator
    else if (moneyFormat.indexOf('{{amount_with_comma_separator}}') > -1) {
      // If there are no cents or money amount is more than 10, remove decimals
      if ( (val.indexOf(',00') > -1) || parseInt(val.replace(/[^0-9]/g, ''), 10) > 1000 ) {
        return val.split(',')[0];
      }
    }
  }
  return val;
};

// Initialize Timber's JS on docready
$(timber.init)
/* ================ SECTIONS ================ */ 
window.theme = window.theme || {};

theme.HeaderSection = (function() {

  function Header() {
    timber.cacheSelectors();
    timber.toggleMenu();

    $(window).on('load', timber.responsiveNav).resize();
  }

  return Header;
})();

if($('body').hasClass('template-index')) {
  theme.Slideshow = (function(el) {    
    this.cache = {
      $slider: $(el),
      sliderArgs: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: $(el).data('slider-home-auto'),
        autoplaySpeed: $(el).data('slider-home-rate'),
        infinite: $(el).data('slider-home-infinite'),
        dots: $(el).data('slider-home-dots'),
        adaptiveHeight: true        
      }
    }
    if (this.cache.$slider.find('li').length === 1) {
      this.cache.sliderArgs.touch = false;
    }
    this.cache.$slider.not('.slick-initialized').slick(this.cache.sliderArgs)

  });  

  theme.slideshows = theme.slideshows || {};

  theme.SlideshowSection = (function() {

    function SlideshowSection(container) {
      var $container = this.$container = $(container);
      var id = $container.attr('data-section-id');
      var slideshow = this.slideshow = '#slideshow--' + id;
      theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    }

    return SlideshowSection;

  })();

  theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {

    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      !function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return-1==n.indexOf(e)&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{},n=i[t]=i[t]||{};return n[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return-1!=n&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=0,o=i[n];e=e||[];for(var r=this._onceEvents&&this._onceEvents[t];o;){var s=r&&r[o];s&&(this.off(t,o),delete r[o]),o.apply(this,e),n+=s?0:1,o=i[n]}return this}},t}),function(t,e){"use strict";"function"==typeof define&&define.amd?define(["ev-emitter/ev-emitter"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter")):t.imagesLoaded=e(t,t.EvEmitter)}(window,function(t,e){function i(t,e){for(var i in e)t[i]=e[i];return t}function n(t){var e=[];if(Array.isArray(t))e=t;else if("number"==typeof t.length)for(var i=0;i<t.length;i++)e.push(t[i]);else e.push(t);return e}function o(t,e,r){return this instanceof o?("string"==typeof t&&(t=document.querySelectorAll(t)),this.elements=n(t),this.options=i({},this.options),"function"==typeof e?r=e:i(this.options,e),r&&this.on("always",r),this.getImages(),h&&(this.jqDeferred=new h.Deferred),void setTimeout(function(){this.check()}.bind(this))):new o(t,e,r)}function r(t){this.img=t}function s(t,e){this.url=t,this.element=e,this.img=new Image}var h=t.jQuery,a=t.console;o.prototype=Object.create(e.prototype),o.prototype.options={},o.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},o.prototype.addElementImages=function(t){"IMG"==t.nodeName&&this.addImage(t),this.options.background===!0&&this.addElementBackgroundImages(t);var e=t.nodeType;if(e&&d[e]){for(var i=t.querySelectorAll("img"),n=0;n<i.length;n++){var o=i[n];this.addImage(o)}if("string"==typeof this.options.background){var r=t.querySelectorAll(this.options.background);for(n=0;n<r.length;n++){var s=r[n];this.addElementBackgroundImages(s)}}}};var d={1:!0,9:!0,11:!0};return o.prototype.addElementBackgroundImages=function(t){var e=getComputedStyle(t);if(e)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(e.backgroundImage);null!==n;){var o=n&&n[2];o&&this.addBackground(o,t),n=i.exec(e.backgroundImage)}},o.prototype.addImage=function(t){var e=new r(t);this.images.push(e)},o.prototype.addBackground=function(t,e){var i=new s(t,e);this.images.push(i)},o.prototype.check=function(){function t(t,i,n){setTimeout(function(){e.progress(t,i,n)})}var e=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(e){e.once("progress",t),e.check()}):void this.complete()},o.prototype.progress=function(t,e,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!t.isLoaded,this.emitEvent("progress",[this,t,e]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,t),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&a&&a.log("progress: "+i,t,e)},o.prototype.complete=function(){var t=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(t,[this]),this.emitEvent("always",[this]),this.jqDeferred){var e=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[e](this)}},r.prototype=Object.create(e.prototype),r.prototype.check=function(){var t=this.getIsImageComplete();return t?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},r.prototype.getIsImageComplete=function(){return this.img.complete&&void 0!==this.img.naturalWidth},r.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.img,e])},r.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},r.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},r.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},r.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(r.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var t=this.getIsImageComplete();t&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.element,e])},o.makeJQueryPlugin=function(e){e=e||t.jQuery,e&&(h=e,h.fn.imagesLoaded=function(t,e){var i=new o(this,t,e);return i.jqDeferred.promise(h(this))})},o.makeJQueryPlugin(),o});

      var $slideshow = $(this.slideshow);
      var $slide = $('.slide--' + evt.detail.blockId);

      var slideIndex = $slide.data('slider-index');
      var $slideImg = $slide.find('img') || $slide.find('svg');

      $slide.imagesLoaded($slideImg,function(){
        $slideshow.slick('slickGoTo', slideIndex);
        //$slideshow.slick('autoPlay', false);      
      });
      
      //$(this.slideshow).slick('autoPlay', $(el).data('slider-home-auto'));
    },

    onBlockDeselect: function() {
      $(this.slideshow).slick('autoPlay', 0);
    }

  });

}
/* eslint-disable no-new */
theme.Product = (function() {
  var defaults = {
    selectors: {
      addToCart: '#addToCart',
      addToCartProduct: '#addToCartProduct',
      productPrice: '#productPrice',
      comparePrice: '#comparePrice',
      addToCartText: '#addToCartText',
      addToCartProductText: '#addToCartProductText',
      addToCheckoutText: '#addToCheckoutText',      
      quantityElements: '.quantity-selector, label + .js-qty',
      optionSelector: 'productSelect',
    }
  };

  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');

    this.settings = $.extend({}, defaults, {
      sectionId: sectionId,
      enableHistoryState: true,
      showComparePrice: $container.attr('data-show-compare-at-price'),
      stockSetting: $container.attr('data-stock'),
      incomingMessage: $container.attr('data-incoming-transfer'),
      selectors: {
        $originalSelectorId: 'productSelect-' + sectionId,
        $addToCart: $('#addToCart'),
        $addToCartProduct: $('#addToCartProduct'),
        $addToCheckout: $('#addToCheckout'),
        $SKU: $('.variant-sku'),
        $productPrice: $('#productPrice-' + sectionId),
        $comparePrice: $('#comparePrice-' + sectionId),
        $addToCartText: $('.addToCartText-' + sectionId),
        $addToCartProductText: $('.addToCartText-' + sectionId),
        $addToCheckoutText: $('#addToCheckoutText-' + sectionId),
        $quantityElements: $('#quantity-selector-' + sectionId),
        $variantQuantity: $('#variantQuantity-' + sectionId),
        $variantIncoming: $('#variantIncoming-' + sectionId),
        unitPriceContainer: '[data-unit-price-container]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-price-base-unit]',
        $productImageWrap: $('#productPhoto-' + sectionId),
        $productImage: $('#productPhotoImg-' + sectionId),
        $thumbImages: $('#productThumbs-' + sectionId).find('a.product-photo-thumb'),
      }
    });

    // disable history state if on homepage
    if($('body').hasClass('template-index')) {
      this.settings.enableHistoryState = false;
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    // this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
    this.productSingleObject = JSON.parse($('#ProductJson-' + sectionId).html());
    this.addVariantInfo();
    this.init();

    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
    /*Shopify.Image.preload(this.productSingleObject.images);*/
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    
   
    init: function() {
      this.initProductVariant();
      this.addQuantityButtons();
      this.productImageSwitch();
      this.initBreakpoints();
	  
      if (timber.vars.isLargeBp) {
        productImageZoom();
      }
    },

    onUnload: function() {
      this.$container.off(this.settings.sectionId);
    },

    addVariantInfo: function() {
      if (!this.productSingleObject) {
        return;
      }

      if (this.settings.stockSetting === 'false' && this.settings.incomingMessage === 'false'){
        return;
      }

      var variantInfo = JSON.parse($('#VariantJson-' + this.settings.sectionId).html());
      for (var i = 0; i < variantInfo.length; i++) {
        $.extend(this.productSingleObject.variants[i], variantInfo[i]);
      }
    },

    addQuantityButtons: function(){
      if (this.settings.selectors.$quantityElements){
        this.settings.selectors.$quantityElements.show();
       
        this.qtySelectors();
       
      }

    },

    qtySelectors: function() {

      validateQty = function (qty) {
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
          return qty;
        } else {
          // Not a number. Default to 1.
          return 1;
        }
      };

      // Change number inputs to JS ones, similar to ajax cart but without API integration.
      // Make sure to add the existing name and id to the new input element
      var numInputs = $('input[type="number"]');

      // Qty selector has a minimum of 1 on the product page
      // and 0 in the cart (determined on qty click)
      var qtyMin = 0;

      if (numInputs.length) {
        numInputs.each(function() {
          var el = $(this),
              currentQty = parseInt(el.val()),
              inputName = el.attr('name'),
              inputId = el.attr('id');

          var itemAdd = currentQty + 1,
              itemMinus = currentQty - 1,
              itemQty = currentQty;

          var source   = $("#jsQty").html(),
              template = Handlebars.compile(source),
              data = {
                key: el.data('id'),
                itemQty: itemQty,
                itemAdd: itemAdd,
                itemMinus: itemMinus,
                inputName: inputName,
                inputId: inputId
              };

          // Append new quantity selector then remove original
          el.after(template(data)).remove();
        });

        // Setup listeners to add/subtract from the input
        $('.js--qty-adjuster').on('click', function() {
          var el = $(this),
              id = el.data('id'),
              qtySelector = el.siblings('.js--num'),
              qty = parseInt( qtySelector.val() );

          var qty = validateQty(qty);
          qtyMin = timber.cache.$body.hasClass('template-product') ? 1 : qtyMin;

          // Add or subtract from the current quantity
          if (el.hasClass('js--add')) {
            qty = qty + 1;
          } else {
            qty = qty <= qtyMin ? qtyMin : qty - 1;
          }

          // Update the input's number
          qtySelector.val(qty);
        });

      }
    },

    initBreakpoints: function () {

      var self = this;
      var $container = self.$container;
      self.zoomType = $container.data('zoom-enabled');

      if (!$('html').hasClass('lt-ie9')) {
       
      }

    },

    productImageSwitch: function() {
      if (!this.settings.selectors.$thumbImages.length) {
        return;
      }

      var self = this;

      // Switch the main image with one of the thumbnails
      // Note: this does not change the variant selected, just the image
      self.settings.selectors.$thumbImages.on('click', function(evt) {
        evt.preventDefault();
        var newImage = $(this).attr('href');
        var newImageId = $(this).attr('data-image-id');

        self.switchImage(newImage, { id: newImageId }, self.settings.selectors.$productImage);

      });


    },

    switchImage: function (src, imgObject, el) {
      // Make sure element is a jquery object
      var $el = $(el);
      $el.attr('src', src);

      if (this.settings.selectors.$productImage.attr('data-zoom') && timber.vars.isLargeBp) {
        var zoomSrc = src.replace('_compact.','_1024x1024.').replace('_medium.','_1024x1024.').replace('_large.','_1024x1024.');
        $el.attr('data-zoom', zoomSrc);

        $(function() {
          productImageZoom();
        });
      }

    },

    initProductVariant: function() {
      // this.productSingleObject is a global JSON object defined in theme.liquid
      if (!this.productSingleObject) {
        return;
      }
      $('.selector-wrapper').hide();
      $('.cont-selector .selector-wrapper').attr('style','display:none');
      var self = this;
      this.optionSelector = new Shopify.OptionSelectors(self.settings.selectors.$originalSelectorId, {
        selectorClass: self.settings.selectors.$optionSelectorClass,
        product: self.productSingleObject,
        onVariantSelected: self.productVariantCallback,
        enableHistoryState: self.settings.enableHistoryState,
        settings: self.settings
      });

      // Clean up variant labels if the Shopify-defined
      // defaults are the only ones left
      this.simplifyVariantLabels(this.productSingleObject);

    },

    simplifyVariantLabels: function(productObject) {
      // Hide variant dropdown if only one exists and title contains 'Default'
      if (productObject.variants.length && productObject.variants[0].title.indexOf('Default') >= 0) {
        $('.selector-wrapper').hide();
        $('.cont-selector .selector-wrapper').attr('style','display:none');
      }
      
    },
    

    // **WARNING** This function actually inherits `this` from `this.optionSelector` not
    // from `product` when passed in as a callback for `option_selection.js`
    productVariantCallback: function(variant) {
      
      if (variant) {  
        
        var $unitPriceContainer = $(this.settings.selectors.unitPriceContainer, this.$container);

        $unitPriceContainer.removeClass('product-price-unit--available');

        if (variant.unit_price_measurement) {
          var $unitPrice = $(this.settings.selectors.unitPrice, this.$container);
          var $unitPriceBaseUnit = $(this.settings.selectors.unitPriceBaseUnit, this.$container);

          $unitPrice.text(Shopify.formatMoney(variant.unit_price, moneyFormat));
          //$unitPriceBaseUnit.text(this.getBaseUnit(variant));
          $unitPriceContainer.addClass('product-price-unit--available');
        }
        
        // Update variant image, if one is set
        if (variant.featured_image) {
          var newImg = variant.featured_image,
              el = this.settings.selectors.$productImage[0],
              zoomSrc = $(newImg).attr('src').replace('.jpg','_1024x1024.jpg').replace('.jpeg','_1024x1024.jpeg').replace('.png','_1024x1024.png'),
              $zoomImg = $('.zoomImg');          
          
          /*function associatedVariantsWithImages(sliderId, newImg, i) {
            let slideActif = $(sliderId+ " .slider-product-thumbnails").find("[data-variant-id='" + newImg.variant_ids[i] + "']");
            let slideActifSelected = slideActif.attr('data-position2');               

            if(slideActifSelected !== undefined) {
              $(sliderId+ ' .slider-product').slick('slickGoTo',slideActifSelected - 1);
            }
            else {
              $(sliderId+ ' .slider-product').slick('slickGoTo',0);
            }               
          }*/
          
          let nbVisits = document.querySelector('.section-product-single').getAttribute('data-page-count');
          var templates = $('div').find("[data-section-slider-id]");
          var mediaVideo = $('.slider-product div').find("[data-media='video']");
          
          
          /*for(let s=0; s < templates.length; s++) {
            var sliderId = "#"+$(templates[s]).attr('id'); 
            console.log('nb de slider produit');            
            var medias = $('.slider-product div').find("[data-media]");  
            for(i=0; i < medias.length; i++) {
              let newId;
              if (medias[i].getAttribute('data-media') == 'video') {
                console.log('on a une video ou plus');
                newId= i+1;
              } 
              else {
              
                newId= i;
              }
              
              associatedVariantsWithImages(sliderId, newImg, newId);

            }
          }*/
          
          if(nbVisits != "0") {
            for(let s=0; s < templates.length; s++) {
              var sliderId = "#"+$(templates[s]).attr('id'); 
              var medias = $('.slider-product div').find("[data-media]");  
              for(i=0; i < medias.length; i++) {
                let slideActif = $(sliderId+ " .slider-product-thumbnails").find("[data-variant-id='" + newImg.variant_ids[i] + "']");
				if(slideActif.length == 1) { 
                  
                  let slideActifSelected = slideActif.attr('data-position2');  
                  if(slideActifSelected !== undefined ) {
                    $(sliderId+ ' .slider-product').slick('slickGoTo',slideActifSelected - 1);
                  }
                  else {
                    $(sliderId+ ' .slider-product').slick('slickGoTo',0);
                  }               
                }
              }
            }             
          }
          
          /*$('.single-option-selector').change(function() { 
          Shopify.Image.switchImage(newImg, el, this.switchImage);
          });        
          
          Shopify.Image.switchImage(newImg, el, this.switchImage);*/

          if (this.settings.selectors.$productImage.attr('data-zoom') && timber.vars.isLargeBp) {
            // reint zoom attributes on image variant
            this.settings.selectors.$productImage.attr('data-zoom', zoomSrc);
            $zoomImg.attr('src', zoomSrc);
          }
        }

        if (variant.available) {
          
          
          // We have a valid product variant, so enable the submit button
          this.settings.selectors.$addToCart.removeClass('disabled').prop('disabled', false);
          this.settings.selectors.$addToCartText.html("Ajouter au panier");
          this.settings.selectors.$addToCartProduct.removeClass('disabled').prop('disabled', false);
          this.settings.selectors.$addToCartProductText.html("Ajouter au panier");
          this.settings.selectors.$addToCheckout.removeClass('disabled').prop('disabled', false);
          this.settings.selectors.$addToCheckoutText.html("Acheter maintenant");

          this.settings.selectors.$variantQuantity.removeClass('is-visible');
          this.settings.selectors.$variantIncoming.removeClass('is-visible');

          if (variant.inventory_management) {
            // Show how many items are left, if below 10
            if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0 && this.settings.stockSetting == 'true') {
              this.settings.selectors.$variantQuantity.html(theme.strings.product.only_left.replace('1', variant.inventory_quantity)).addClass('is-visible');
            }
          }

          // Show next ship date if quantity <= 0 and stock is incoming
          if (variant.inventory_quantity <= 0 && variant.incoming != null ) {
            if (variant.next_incoming_date != null){
              this.settings.selectors.$variantIncoming.html(theme.strings.product.will_be_in_stock_after.replace('[date]', variant.next_incoming_date)).addClass('is-visible');
            }
          }
        } else {          

          // Variant is sold out, disable the submit button
          this.settings.selectors.$addToCart.addClass('disabled').prop('disabled', true);
          this.settings.selectors.$addToCartText.html("Épuisé");
          this.settings.selectors.$addToCartProduct.addClass('disabled').prop('disabled', true);
          this.settings.selectors.$addToCartProductText.html("Épuisé");
          this.settings.selectors.$addToCheckout.addClass('disabled').prop('disabled', true);
          this.settings.selectors.$addToCheckoutText.html("Épuisé");
          this.settings.selectors.$variantQuantity.removeClass('is-visible');
          this.settings.selectors.$variantIncoming.removeClass('is-visible');

          // Show next stock incoming date if stock is incoming
          if (variant.inventory_management) {
            if (variant.incoming && this.settings.incomingMessage == 'true' && variant.incoming != null && variant.next_incoming_date != null) {
              this.settings.selectors.$variantIncoming.html(theme.strings.product.will_be_in_stock_after.replace('[date]', variant.next_incoming_date)).addClass('is-visible');
            }
          }

          this.settings.selectors.$quantityElements.hide();
        }

        // Regardless of stock, update the product price
        var customPrice = timber.formatMoney( Shopify.formatMoney(variant.price, moneyFormat) );   
        
        var customComparePrice = timber.formatMoney( Shopify.formatMoney(variant.compare_at_price, moneyFormat) ); 
        var a11yPrice = Shopify.formatMoney(variant.price, moneyFormat);
                
        var customPriceWithoutCurrency = "";    
        var customComparePriceWithoutCurrency = "";
        
              
        
        // v1 
        
        var customPriceFormat = ' <span aria-hidden="true" class="so-price" id="so-price" data-compare-price="'+customComparePriceWithoutCurrency+'" data-price="'+customPriceWithoutCurrency+'" data-shipping-value="none" data-discount-qty2="10" data-discount-qty3="15">' + customPrice + '</span>';
         
        
        // v2
         
        
        customPriceFormat += ' <span class="visually-hidden">' + a11yPrice + '</span>';

        // Show SKU
        this.settings.selectors.$SKU.html(variant.sku)

        if (this.settings.showComparePrice == 'true' ) {
          if (variant.compare_at_price > variant.price) {
            var comparePrice = timber.formatMoney(Shopify.formatMoney(variant.compare_at_price, moneyFormat));
            var a11yComparePrice = Shopify.formatMoney(variant.compare_at_price, moneyFormat);
            
            // v1 
            
            var customPriceFormat = ' <span aria-hidden="true" class="so-price" id="so-price" data-compare-price="'+customComparePriceWithoutCurrency+'" data-price="'+customPriceWithoutCurrency+'" data-shipping-value="none" data-discount-qty2="10" data-discount-qty3="15">' + customPrice + '</span>';
             

            // v2
             
            
            customPriceFormat += ' <span aria-hidden="true"><s>' + comparePrice + '</s></span>';
            customPriceFormat += ' <span class="visually-hidden"><span class="visually-hidden">Prix régulier</span> ' + a11yComparePrice + '</span>';
            customPriceFormat += ' <span class="visually-hidden"><span class="visually-hidden">Prix réduit</span> ' + a11yPrice + '</span>';
             
          }
        }
        
        // special offer v1 - free shipping - discount auto
        
        
        this.settings.selectors.$productPrice.html(customPriceFormat);

        // Also update and show the product's compare price if necessary
        if ( variant.compare_at_price > variant.price ) {
          var priceSaving = Shopify.formatMoney(variant.compare_at_price - variant.price, moneyFormat);
          
          var priceSaving = '<span class="price-sale2"> ' + priceSaving + '</span>';
          var priceSaving2 = timber.formatSaleTag( Shopify.formatMoney(variant.compare_at_price - variant.price, "") );
          var priceSaving2 = ((variant.compare_at_price - variant.price)/variant.compare_at_price*100).toFixed()+"%";
		         
          this.settings.selectors.$comparePrice.html("\u003cspan class='save-text'\u003eAu lieu de 39,60 €\u003c\/span\u003e ".replace('[$]', priceSaving + " <span class='price-saving-percent'><span class='parentheses'>(</span>-" + priceSaving2 + "<span class='parentheses'>)</span></span>")).show();
                   
        } 
        else {
          this.settings.selectors.$comparePrice.hide();
          
        }
        
        if (variant.compare_at_price == variant.price) {
          
          $('.main-content .amount-percent-true .product-meta .sale-tag').hide();
         
        }       
       

      } else {
        // The variant doesn't exist, disable submit button.
        // This may be an error or notice that a specific variant is not available.
        this.settings.selectors.$addToCart.addClass('disabled').prop('disabled', true);
        this.settings.selectors.$addToCartText.html(theme.strings.product.unavailable);
        this.settings.selectors.$addToCartProduct.addClass('disabled').prop('disabled', true);
        this.settings.selectors.$addToCartProductText.html(theme.strings.product.unavailable);
        this.settings.selectors.$addToCheckout.addClass('disabled').prop('disabled', true);
        this.settings.selectors.$addToCheckoutText.html(theme.strings.product.unavailable);
        this.settings.selectors.$variantQuantity.removeClass('is-visible');
        this.settings.selectors.$quantityElements.hide();
      }

    }

  });

  function productImageZoom() {

    var $productImageWrap = $('.productPhoto'),
        $productImage = $('.productPhotoImg');

    if (timber.vars.isLargeBp) {
      if (!$productImage.attr('data-zoom')) {
        return;
      }

      if (!$productImageWrap.length || timber.cache.$html.hasClass('supports-touch')) {
        return;
      };

      // Destroy zoom (in case it was already set), then set it up again
      $productImageWrap.trigger('zoom.destroy');
      $productImageWrap.addClass('image-zoom').zoom({
        url: $productImage.attr('data-zoom')
      });
    }
  }
  return Product;
})();
$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('product-template', theme.Product);
});


/* Applications */

// Size chart

$(document).ready(function() {
  
  function productTabs() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      if($(this).attr('data-active') == "false") {
        active = links.first().addClass('active');
      } 
      else {
        active = links.first().removeClass('active');
        $('#tab-1').hide();
      }
      
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  }
  productTabs();
  jQuery(document).on('shopify:section:load', function(){  
    productTabs();
  });
  
  if (window.matchMedia("(min-width: 800px)").matches) {  
    window.addEventListener('scroll', _.debounce(function(){ 
      var a = 112;
      var pos = $(window).scrollTop();
      
      if(pos > a) {
        
        $(".size-format-true .cont-header").css({'background':'rgba(255,255,255,0.75);'});        
        $(".header-fixed-true").addClass('header-scroll-on');
        $(".header-fixed-true").removeClass('header-scroll-off');
      }
      else {
       
        $(".size-format-true .cont-header").css({'background':'rgba(255,255,255,0.99);'});       
        $(".header-fixed-true").removeClass('header-scroll-on');
        $(".header-fixed-true").addClass('header-scroll-off');
      }
    }, 1));
    
     /*document.querySelector(".cont-header").addEventListener('mouseover', _.debounce(function(){ 
       $(".header-fixed-true").addClass('header-scroll-on');
       $(".header-fixed-true").removeClass('header-scroll-off');
    }, 200));*/
    /*document.querySelector(".cont-header").addEventListener('mouseleave', _.debounce(function(){ 
       $(".header-fixed-true").removeClass('header-scroll-on');
      $(".header-fixed-true").addClass('header-scroll-off');
    }, 200))*/
  }
});
$(window).on("load resize",function(e){  
  $('.template-collection .mono-produit-true').remove('aside');
  $('.template-collection .mono-produit-true .hr--offset-left').css('margin-left','0');  
  $('.template-collection .mono-produit-true .grid-item').removeClass('large--four-fifths'); 
  $('.template-collection .mono-produit-true .grid-item').removeClass('grid-border--left');   
});

function slidersProduct(slider,thumbnails,thumbnails_layout,thumbnails_number) {
  
  jQuery(slider).not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    fade: true,
    asNavFor: thumbnails,
    pauseOnFocus:false
    
  });

  if (thumbnails_layout == "1") {
    jQuery(thumbnails).not('.slick-initialized').slick({
      slidesToShow: thumbnails_number,
      slidesToScroll: 1,
      asNavFor: slider,
      dots: false,
      infinite:false,
      centerMode: false,
      focusOnSelect: true,
      vertical:true,
      verticalSwiping:true
    });
  }
  else {

    jQuery(thumbnails).not('.slick-initialized').slick({
      slidesToShow: thumbnails_number,
      slidesToScroll: 1,
      asNavFor: slider,
      dots: false,
      infinite:false,
      centerMode: false,
      focusOnSelect: true
    });
   
  }

}


if(document.querySelector('.slider-product')) { 
  
  let thumbnailsLayout = $('.slider-product').data('thumbnails-layout');
  let thumbnailsNumber = $('.slider-product').data('thumbnails-number');

  slidersProduct('.slider-product','.slider-product-thumbnails', thumbnailsLayout, thumbnailsNumber);
  jQuery(document).on('shopify:section:load', function(){     
   slidersProduct('.slider-product','.slider-product-thumbnails', thumbnailsLayout, thumbnailsNumber);
  });
}

function sliderRecommendedProducts() {  
  
  jQuery('.template-product .slider-related-products').not('.slick-initialized').slick({ 
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: false,                 
    speed: 300,     
    responsive: [   
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }     
    ]
  });

  $( ".slick-next:after" ).click(function() {
    $('.slick-slide').delay(1000).fadeIn(0);
  });

}
jQuery(document).ready(function () { 
  sliderRecommendedProducts();
});
jQuery(document).on('shopify:section:load', function(){  
  sliderRecommendedProducts();
});


function sliderProducts(id, desktop, mobile, centerMode) {
  
  jQuery('#section-id-'+id+' .slick-slider').not('.slick-initialized').slick({ 
    infinite: true,
    slidesToShow: desktop,
    slidesToScroll: 1,
    adaptiveHeight: true,
    dots: false,                 
    speed: 300,     
    responsive: [   
      {
        breakpoint: 900,
        settings: {
          slidesToShow: desktop,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: mobile,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: mobile,
          slidesToScroll: 1,        
          centerMode: centerMode,
          centerPadding: '50px'
        }
      }     
    ]
  
});
}

// .on('setPosition', function (event, slick) {	slick.$slides.css('height', slick.$slideTrack.height() + 'px');


/*if($("#showcdtimer").length > 0){ 
  $('#gdcdtimer').show(); 
}
else {
  $('#gdcdtimer').hide(); 
}*/

$(".cont-photos .flex-control-nav").hide();
$('.carousel-inner .item').eq(0).addClass('active');

$(document).ready(function() {   
  
  $('.search-bar').hover(function() {
    $( ".search-input" ).focus();
  });

  $(".product-variants option").each(function() {
    var text = $(this).text();
    text = text.replace("Default Title", "Prix");
    $(this).text(text);
  });   
  $(".product-variants2 option").each(function() {
    var text = $(this).text();
    text = text.replace("Default Title", "Prix");
    $(this).text(text);
  });
  var goContent = $(".slider-section").attr('id');
  setTimeout(function() {
    
   
    var sliderHeight = $(".slider-section").height();
    var HeaderSection = ($(".cont-header").height() -37);
    var HeaderSectionMobile = ($(".cont-header").height());
    $(".movearrow").eq(0).show();

    $('.movearrow').on('click', function() { 

      $('html,body').animate({
        scrollTop: ($("#" + goContent).offset().top) + sliderHeight},'slow');
    });

  }, 1000);
  
});
$(function(){$.fn.scrollToTop=function(){$(this).hide().removeAttr("href");if($(window).scrollTop()!="0"){$(this).fadeIn("slow")}var scrollDiv=$(this);$(window).scroll(function(){if($(window).scrollTop()=="0"){$(scrollDiv).fadeOut("slow")}else{$(scrollDiv).fadeIn("slow")}});$(this).click(function(){$("html, body").animate({scrollTop:0},"slow")})}}); 
$(function(){
 $("#toTop").scrollToTop();
});

$(function(){$.fn.scrollToTop=function(){$(this).hide().removeAttr("href");if($(window).scrollTop()!="0"){$(this).fadeIn("slow")}var scrollDiv=$(this);$(window).scroll(function(){if($(window).scrollTop()=="0"){$(scrollDiv).fadeOut("slow")}else{$(scrollDiv).fadeIn("slow")}});$(this).click(function(){$("html, body").animate({scrollTop:0},"slow")})}}); 
$(function(){
 $("#toTop").scrollToTop();
});

$(window).on('load', function() {
  if (window.matchMedia("(min-width: 1024px)").matches) {
    $(document).on('mousemove', '.frame', function(event) {

      var element = {
        width: $(this).width(),
        height: $(this).height()
      };

      var mouse = {
        x: event.pageX,
        y: event.pageY
      };

      var offset = $(this).offset();

      var origin = {
        x: (offset.left + (element.width / 2)),
        y: (offset.top + (element.height / 2))
      };

      var trans = {
        left: (origin.x - mouse.x) / 2,
        down: (origin.y - mouse.y) / 2
      };

      var transform = ("scale(2,2) translateX(" + trans.left + "px) translateY(" + trans.down + "px)");

      $(this).children(".zoom").css("transform", transform);

    });
    $(document).on('mouseleave', '.frame', function() {
      $(this).children(".zoom").css("transform", "none");
    });
    $("#sortBy option").each(function(i) {
      var $bestSelling = $(this).attr("value");
      if ($bestSelling == "best-selling") {
        $(this).hide();
      }
    });
  }
});

$(document).ready(function() {
  /* Header cart */
  /* CGV */
    

    

});

function checkHeaderSize() {
  var headerHeight = $('.cont-header').height();
  var hasClassHeaderFixed = $('.cont-header').hasClass('header-fixed-true'); 
  
  if (window.matchMedia("(max-width: 1023px)").matches) {
    var hasClassHeaderFixed = true;
    $('.cont-header').removeClass('header-fixed-false');
    $('.cont-header').addClass('header-fixed-true');   
  }
  
  $('.menu-toggle').on('click', function() {     
    
    if ($('html').hasClass('show-nav')) {
      $('.show-nav .nav-bar').attr('style','top:'+headerHeight+'px;padding-bottom:'+headerHeight+'px;'); 
    }
    else {
      $('.nav-bar').attr('style','top:110% !important'); 
    }

  });

  if(hasClassHeaderFixed) {  
    
    $('.main-content').attr('style','padding-top:'+(headerHeight)+'px !important');
    $('.template-index .main-content').attr('style','padding-top:'+headerHeight+'px');

  } 
  else {
    $('.main-content').attr('style','padding-top:25px');
    $('.template-index .main-content').attr('style','padding-top:0');
    
  }
}

$(window).on("load resize",function(e){ 
  checkHeaderSize();
});




// Open the full screen search box
function openSearch() {
  const input = document.querySelectorAll(".search-overlay .search-input");
  document.getElementById("search-overlay").style.display = "block";
  setTimeout(function() {
    input[0].focus();

  }, 600);
}
// Close the full screen search box
function closeSearch() {
  document.getElementById("search-overlay").style.display = "none";
}
$(document).ready(function() {
  
  $(".update-cart").hide();
  $('.template-cart .cart__quantity-selector').change(function(){
    $( ".update-cart" ).click();
  });
  
  var regEx = /(\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)/;

  $(".site-footer p").filter(function() {
    return $(this).html().match(regEx);
  }).each(function() {
    $(this).html($(this).html().replace(regEx, "<a href=\"mailto:$1\">$1</a>"));
  });
});
/* Menu icons */ 
                                                

jQuery(function() {
  
  // Current Ajax request.
  var currentAjaxRequest = null;
  // Grabbing all search forms on the page, and adding a .search-results list to each.
  var searchForms = jQuery('form[action="/search"]').css('position','relative').each(function() {
    // Grabbing text input.
    var input = jQuery(this).find('input[name="q"]');
    // Adding a list for showing search results.
    var offSet = input.position().top + input.innerHeight();
    jQuery('<ul class="search-results"></ul>').css( { 'position': 'absolute', 'left': '0px', 'top': '100%' } ).appendTo(jQuery(this)).hide();    
    // Listening to keyup and change on the text field within these search forms.
    input.attr('autocomplete', 'off').bind('keyup change', function() {
      // What's the search term?
      var term = jQuery(this).val() + "*";
      // What's the search form?
      var form = jQuery(this).closest('form');
      // What's the search URL?      
      
      var searchURL = '/search?type=product&q=' + term;
      // What's the search results list?
      var resultsList = form.find('.search-results');
      // If that's a new term and it contains at least 3 characters.
      if (term.length > 3 && term != jQuery(this).attr('data-old-term')) {
        // Saving old query.
        jQuery(this).attr('data-old-term', term);
        // Killing any Ajax request that's currently being processed.
        if (currentAjaxRequest != null) currentAjaxRequest.abort();
        // Pulling results.
        currentAjaxRequest = jQuery.getJSON(searchURL + '&view=json', function(data) {
          // Reset results.
          resultsList.empty();
          // If we have no results.
          if(data.results_count == 0) {
            // resultsList.html('<li><span class="title">No results.</span></li>');
            // resultsList.fadeIn(200);
            resultsList.hide();
          } else {
            // If we have results.
            jQuery.each(data.results, function(index, item) {
              var link = jQuery('<a></a>').attr('href', item.url);
              if (item.thumbnail.includes('no-image')) {
              link.append('<span class="thumbnail"></span>');
              }
              else {
                link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
                
              }              
              link.append('<span class="title">' + item.title + '</span>');
              link.wrap('<li></li>');
              resultsList.append(link.parent());
            });
            // The Ajax request will return at the most 10 results.
            // If there are more than 10, let's link to the search results page.
            if(data.results_count > 10) {
              resultsList.append('<li><span class="title"><a href="' + searchURL + '">Voir tous les produits (' + data.results_count + ')</a></span></li>');
            }
            resultsList.fadeIn(200);
          }        
        });
      }
    });
  });
  // Clicking outside makes the results disappear.
  jQuery('body').bind('click', function(){
    jQuery('.search-results').hide();
  });
});

  



function simulateLink() {
  let gridImages = document.querySelectorAll('.simulate-link');
  for (let i = 0; i < gridImages.length; i++) {       
    gridImages[i].addEventListener('click', function() {
      let link = gridImages[i].dataset.link;     
      window.location.href = link;        
    }, {passive: true});
  }
}    

simulateLink();    





function accordeonMobile (selector,opacity) { 
  const panelTitles = document.querySelectorAll(selector);
  for (let i = 0; i < panelTitles.length; i++) {
    const panelTitle = panelTitles[i];
    panelTitle.classList.add("accordeon-panel-title");
    const addChevron = '<i class="fa fa-chevron-down"></i>';
    panelTitle.insertAdjacentHTML('beforeend', addChevron);
    const panelContent = panelTitles[i].nextElementSibling;
    panelContent.classList.add("accordeon-panel-hidden");   
    panelTitle.addEventListener("click", function() {    
      panelContent.classList.toggle("accordeon-panel-show");    
      panelTitle.classList.toggle("accordeon-open"); 
    }, {passive: true});
  }
}

if (window.matchMedia("(max-width: 600px)").matches) {
    
    accordeonMobile("footer .h3","9"); 
    
  
  /*const hasWidget = document.querySelectorAll('.widget');
  if(hasWidget[0]) {
    accordeonMobile(".widget .toggle","9");
  } */
   
} 



// collections 

function collectionUtils (id) {
  let section = document.getElementById(id);    

  let gridTitlesCrop = document.querySelectorAll(`#${id} .grid-crop-title`);
  let gridTitles = document.querySelectorAll(`#${id} .title-truncate`);
  let gridHeight = section.getAttribute('data-title-height');
  let gridHeightSm = section.getAttribute('data-title-height-sm');
  let titleTruncate = section.getAttribute('data-title-truncate');
  let titleTruncateSm = section.getAttribute('data-title-truncate-sm');
  function truncateString(str, num) {

    if (str.length <= num) {
      return str
    }

    return str.slice(0, num) + '...'
  }

  for(i = 0; i < gridTitles.length; i++) {
    let textTitle = gridTitles[i].textContent;
    let num;
    if(window.matchMedia("(min-width:768px)").matches) {
      num = titleTruncate;
    } 
    else {
      num = titleTruncateSm;
    }
    gridTitles[i].textContent = truncateString(textTitle, num);     
  }

  for(i = 0; i < gridTitlesCrop.length; i++) {
    let titleHeight = gridTitlesCrop[i];
    if(window.matchMedia("(min-width:768px)").matches) {       
      titleHeight.style.minHeight = gridHeight+'px';
    } 
    else {
      titleHeight.style.minHeight = gridHeightSm+'px';
    }   
  }

}
   
$(document).ready(function() { 
  (function() {    
    const contVideoPlayer = document.querySelector('.video-play');
    if(contVideoPlayer) {
      const videoPlayerBtn = document.querySelector('.product-video-icon');
      const videoPlayer = document.querySelectorAll('.video-play video');    

      function showPlayBtn(elem) {
        document.querySelector('.product-video-icon').style.display = "none";
        if (elem.paused == false) {
          document.querySelector('.product-video-icon').style.display = "flex";
        } else {
          document.querySelector('.product-video-icon').style.display = "none";
        }
      }
      function playerVideo1(elem) {
        elem.addEventListener("click", function() {        
          showPlayBtn(elem);        
        });      
      }

      function playerVideo2(elem) {
        elem.addEventListener("click", function() {
          videoPlayer[0].play(); 
          showPlayBtn(elem);
        });      
      }

      playerVideo1(videoPlayer[0]);
      playerVideo2(videoPlayerBtn);
    }
    const productId  = document.querySelectorAll('.section-product-single');  
    if(productId[0]) {
    if(productId[0].getAttribute("data-product-form-layout") == "2") {
      
      let selector = ".swatch .header";
      
      if(document.querySelectorAll(selector)) {
        let variantsCount = document.querySelectorAll(selector);

        if(variantsCount.length > 1) {
          $(selector).each(function(index) {

            let content = $(this).text();
            $(this).html(`<span class="header-number">${index + 1}</span>${content} : `);
            
          });
        }
        let contentQty = $('.product-form-layout-2 .quantity-selector').eq(0).text();
        $('.product-form-layout-2 .quantity-selector').html(`<span class="header-number">${variantsCount.length + 1}</span>${contentQty} : `);
      }
    } 
    }
  })();
});  